module.exports = __webpack_public_path__ + "img/iocn-2.41314599.png";